// /src/pdf/builders/geo/buildDoc.js
export function buildGeoDoc({
  t, shortcode, stationName,
  startDate, endDate,
  rows, total, nogeo,
  fmtNumber, locale,
  logoDataUrl,
  serviceName
}) {
  // Шапка таблицы без эмодзи (pdfmake Roboto не покрывает)
  const header = [
    { text: t('geo.table.country'), style: 'th', alignment: 'left' },
    { text: t('geo.table.listeners'), style: 'th', alignment: 'right' },
  ];
  const stationTitle = stationName || shortcode || '';
  const serviceTitle = serviceName || (t && t('geo.title')) || '';

  // Тело таблицы: все страны КРОМЕ «Без географії», затем строка «Без географії»
  const knownRows = (rows || [])
    .filter(r => r && r.country && r.country !== 'Без географії')
    .map(r => ([
      { text: r.country, alignment: 'left' },
      { text: fmtNumber(r.listeners ?? 0, locale), alignment: 'right' },
    ]));

  const unknownRow = [
    { text: t('geo.unknown'), alignment: 'left' },
    { text: fmtNumber(nogeo ?? 0, locale), alignment: 'right' },
  ];

  const body = [header, ...knownRows, unknownRow];

  const content = [];

  // Лого слева (если есть)
  if (logoDataUrl) {
    content.push({ image: logoDataUrl, width: 140, margin: [0, 0, 0, 10] });
  }

  // Заголовок и параметры периода
  content.push(
    ...(serviceTitle ? [{ text: serviceTitle, style: 'h1', margin: [0, 0, 0, 2] }] : []),
    ...(stationTitle ? [{ text: stationTitle, style: 'h1', margin: [0, 0, 0, 4] }] : []),
    {
      margin: [0, 0, 0, 6],
      fontSize: 10,
      color: '#666',
      stack: [
        `${t('geo.from')}: ${startDate}`,
        `${t('geo.to')}: ${endDate}`,
      ],
    },
    {
      text: (t && t('pdf.made_on')) || 'Report made on Radiomonitor.net',
      fontSize: 10,
      color: '#666',
      margin: [0, 0, 0, 10],
    },
    {
      table: {
        headerRows: 1,
        widths: ['*', 'auto'],
        body,
      },
      layout: {
        fillColor: (rowIndex) => (rowIndex === 0 ? '#f0f0f0' : null),
        hLineColor: '#e0e0e0',
        vLineColor: '#e0e0e0',
      },
    },
    {
      margin: [0, 8, 0, 0],
      columns: [
        { text: (t('geo.total', { count: total ?? 0, value: fmtNumber(total ?? 0, locale), total: total ?? 0 })), style: 'totalValue', alignment: 'right' }
      ],
    }
  );

  return {
    pageSize: 'A4',
    pageMargins: [24, 28, 24, 36],
    footer: (current, totalPages) => ({
      margin: [24, 0, 24, 12],
      fontSize: 9,
      columns: [
        { text: `${(t && t('pdf.made_on')) || 'Report made on Radiomonitor.net'}`, alignment: 'left' },
        { text: `${current} / ${totalPages}`, alignment: 'right' },
      ],
    }),
    content,
    styles: {
      h1: { fontSize: 18, bold: true },
      th: { bold: true },
      totalValue: { fontSize: 12, bold: true },
    },
  };
}

export { buildGeoDoc as default };
